import { AxMediaPreviewContentDialog } from "@/components/ax/mediaGallery/AxMediaPreviewContentDialog";
import { parsePreviewConfig } from "@/components/ax/mediaGallery/ParsePreviewConfig";
import { Content } from "@/lib/types";
import { EyeIcon } from "lucide-react";
import { useState } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";

interface Props {
  contentDetails: Content;
}

export const SelectedMediaPreviewContentDialog: React.FC<Props> = ({ contentDetails }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const parsedPreviewConfig = parsePreviewConfig(
    contentDetails.contentType,
    contentDetails.contentStorageName,
    contentDetails.contentLink,
    contentDetails.name
  );

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <EyeIcon className="w-4 h-4 cursor-pointer" onClick={() => setIsOpen(true)} />
        </TooltipTrigger>
        <TooltipContent>{t("content.preview")}</TooltipContent>
      </Tooltip>

      {isOpen && (
        <AxMediaPreviewContentDialog parsedPreviewConfig={parsedPreviewConfig} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};
